var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1190",
    d: "M41.2526 21.6287C41.2526 32.5134 32.4289 41.3371 21.5443 41.3371C10.6597 41.3371 1.83594 32.5134 1.83594 21.6287C1.83594 10.7441 10.6597 1.92041 21.5443 1.92041C32.4289 1.92041 41.2526 10.7441 41.2526 21.6287Z",
    fill: "#FFBF1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0026 14.2954C17.6994 14.2954 14.2109 17.7839 14.2109 22.0871C14.2109 26.3903 17.6994 29.8787 22.0026 29.8787C26.3058 29.8787 29.7943 26.3903 29.7943 22.0871C29.7943 21.3277 30.4099 20.7121 31.1693 20.7121C31.9287 20.7121 32.5443 21.3277 32.5443 22.0871C32.5443 27.909 27.8246 32.6287 22.0026 32.6287C16.1806 32.6287 11.4609 27.909 11.4609 22.0871C11.4609 16.2651 16.1806 11.5454 22.0026 11.5454C22.762 11.5454 23.3776 12.161 23.3776 12.9204C23.3776 13.6798 22.762 14.2954 22.0026 14.2954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9099 2.90261C34.1992 1.84896 36.0308 2.52966 36.4885 4.00024C36.4927 4.01348 36.4966 4.02677 36.5003 4.04013L37.2991 6.90966L39.9741 7.57039C39.9916 7.57471 40.0091 7.57938 40.0264 7.58438C41.5478 8.02432 42.2339 9.90586 41.1592 11.2036C40.1398 12.4346 38.7881 14.0178 36.9822 14.9419C35.2565 15.8249 33.2213 16.0604 30.845 15.1723L23.027 22.9904C22.49 23.5274 21.6194 23.5274 21.0824 22.9904C20.5454 22.4534 20.5454 21.5828 21.0824 21.0459L28.9379 13.1903C28.0812 10.96 28.2729 8.98361 29.0961 7.27384C29.9919 5.41309 31.5822 3.98757 32.9099 2.90262M31.6401 12.5316C33.4055 13.2394 34.6879 13.0268 35.7295 12.4938C36.768 11.9624 37.6591 11.0685 38.5372 10.0481L35.8602 9.38686C35.3785 9.2679 34.9983 8.89869 34.8652 8.42075L34.0596 5.52691C33.001 6.44071 32.0908 7.39298 31.5739 8.46672C31.0568 9.5407 30.888 10.8297 31.6401 12.5316ZM39.0412 9.44951L39.0412 9.44957L39.0412 9.44951Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget11);
export default __webpack_public_path__ + "static/media/target11.fb636c3264e45685942debf3897cb679.svg";
export { ForwardRef as ReactComponent };